import { render, staticRenderFns } from "./modelDia.vue?vue&type=template&id=37583e84&scoped=true&"
import script from "./modelDia.vue?vue&type=script&lang=js&"
export * from "./modelDia.vue?vue&type=script&lang=js&"
import style0 from "./modelDia.vue?vue&type=style&index=0&id=37583e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37583e84",
  null
  
)

export default component.exports